import React, { useEffect, useState } from "react";
import CollapsibleSection from "./CollapsibleSection";

const imgStyle = {
  margin: "10px",
  maxWidth: "10%",
};

function PastPosters() {
  const [posters, setPosters] = useState([]);

  useEffect(() => {
    fetch(`/pastPosters.json?timestamp=${new Date().getTime()}`)
      .then((response) => response.json())
      .then((data) => setPosters(data));
  }, []);

  if (posters.length === 0) {
    return <div></div>;
  }

  return (
    <>
      <CollapsibleSection
        title='Προηγούμενες εμφανίσεις'
      >
        <div className='sectionStyle'>
          {posters.map((poster) => (
            <img
              key={poster.name}
              style={imgStyle}
              src={poster.name}
              alt={poster.name}
            />
          ))}
        </div>
      </CollapsibleSection>
      <hr className='sectionSeparator' />
    </>
  );
}

export default PastPosters;
